import React from 'react';
import classNames from 'classnames';

import 'scss/icons.scss';
import 'scss/components/lightbox.scss';

function arrow(direction, onClick) {
    if (onClick) {
        const classes = classNames(
            'lightbox__arrow',
            `lightbox__arrow--${direction}`,
            `icon-arrow-${direction}`
        );
        return <div className={classes} onClick={onClick} />;
    }
}

export default function Lightbox({
    onLeft,
    onRight,
    onClose,
    children,
    isPexels,
    className,
    isCloseDisabled
}) {
    const lightboxModalClass = classNames('lightbox__modal', {
        'lightbox_modal--pexels': isPexels
    });
    const lightboxAnchorClass = classNames('lightbox__anchor', {
        'lightbox__anchor--pexels': isPexels
    });
    const lightboxWindowClass = classNames('lightbox__window', {
        'lightbox__window--pexels': isPexels
    });
    const lightboxClose = !isPexels && (
        <i
            className="fa fa-close lightbox__close"
            style={{cursor: isCloseDisabled ? 'not-allowed' : 'pointer'}}
            onClick={() => {
                if (!isCloseDisabled) {
                    onClose();
                }
            }}
        />
    );

    const lightboxRootClassName = classNames('lightbox', {
        [className]: !!className
    });
    return (
        <div className={lightboxRootClassName}>
            <div
                className="lightbox__overlay"
                onClick={() => {
                    if (!isCloseDisabled) {
                        onClose();
                    }
                }}
            />
            <div className={lightboxAnchorClass}>
                <div className={lightboxModalClass}>
                    {arrow('left', onLeft)}
                    {arrow('right', onRight)}
                    <div className={lightboxWindowClass}>
                        {lightboxClose}
                        {children}
                    </div>
                </div>
            </div>
        </div>
    );
}



// WEBPACK FOOTER //
// ./components/lightbox.js